import { Component } from '@angular/core';
import { ConfigService } from '../../modules/client-config/services/config.service';
import { LocalizeContacts } from '../../core/shared/localize-config';
import { OAuthService } from 'src/app/modules/auth/services/oauth.service';

@Component({
  selector: 'app-user-deleted-page',
  templateUrl: './user-deleted-page.component.html',
  styleUrls: ['./user-deleted-page.component.scss'],
})
export class UserDeletedPageComponent {
  contacts: LocalizeContacts;
  constructor(
    public configService: ConfigService,
    public oauthService: OAuthService
  ) {
    this.contacts = configService.localizeContacts;
  }
}

